import {useAsync} from "react-use";
import {useApiClient} from "./useApiClient";

export function useBalance() {
    const apiClient = useApiClient();

    const { value: balance, loading: balanceLoading } = useAsync(async (): Promise<number> => {
        const response = await apiClient.get(`balance`);

        if (!response.ok) {
            console.error('Error fetching balance');
        }

        const data = await response.json();

        return data.balance;
    });

    return { balance, isEnoughBalance: Number(balance) > 0, balanceLoading };
}
